import { MerchantDto, OnlineOrderingConfigurationTypeEnum, OrderTypeNameEnum } from "@up/data";
import { addMinutes } from "date-fns";
import { Schedule } from "../../../../interfaces/src/lib/schedule.interface";

export function isOrderRequestDateValid(
  date: string | Date,
  merchant: MerchantDto,
  schedules: Map<string, Schedule>,
  orderType: string
) {

    if (!date || !schedules || !merchant) {
        return null;
    }

    // Apply time zone adjustment for scheduleKey
    const selectedDate = new Date(date);
    const timezoneOffsetMinutes = selectedDate.getTimezoneOffset();
    const adjustedDate = new Date(selectedDate.getTime() - timezoneOffsetMinutes * 60 * 1000);
    const scheduleKey = adjustedDate.toISOString().slice(0, 10);

    const schedule = schedules.get(scheduleKey);

    if (!schedule) {
      return { invalidDate: true };  // No schedule for the selected date
    }

    const preorderPrintBeforeMinutes = +merchant?.moduleConfigValue?.find(
          (c) =>
            c.configurationType.name === OnlineOrderingConfigurationTypeEnum.preorderPrintBeforeMinutes
        )?.value || 30;
    const averageDeliveryTime = merchant?.deliverArea[0]?.averageDeliveryTime;
    let preparationTime = preorderPrintBeforeMinutes;

    if(orderType === OrderTypeNameEnum.DELIVERY && averageDeliveryTime) {
      preparationTime = preorderPrintBeforeMinutes + averageDeliveryTime;
    }

    const openingTime = schedule.openingTime ? new Date(schedule.openingTime) : new Date(schedule.previousOpeningTime);
    let closingTime = schedule.closingTime ? new Date(schedule.closingTime) : new Date(schedule.previousClosingTime);
    const previousClosingTime = schedule.previousClosingTime;

    // current day closed but has overnight 
    if(!schedule.isOpen) {
      const adjustedDate = new Date(selectedDate.getTime() - timezoneOffsetMinutes * 60 * 1000);

      // To get the schedule key for the previous day
      const previousDay = new Date(adjustedDate.getTime() - 24 * 60 * 60 * 1000);
      const previousDayKey = previousDay.toISOString().slice(0, 10);
      const previousDaySchedule = schedules.get(previousDayKey);

      const isOvernight = (previousDaySchedule.closingTime?.getUTCDate() - previousDaySchedule.openingTime?.getUTCDate()) === 1;

      if(isOvernight) {
        closingTime = previousDaySchedule.closingTime;
      }
    }

    // Don't apply validator on midnight hours but still consider the pre-order time
    const previousClosingTimeDate = previousClosingTime ? new Date(previousClosingTime) : null;
    if (previousClosingTimeDate) {
      const minTimeConsideringPreorder = addMinutes(new Date(), preparationTime);
      const minOrderTimeAtPreviousClosing = previousClosingTimeDate;
      if (new Date(date) <= minOrderTimeAtPreviousClosing && new Date(date) >= minTimeConsideringPreorder) {
        return null;
      }
    }

    // Determine the earliest time the user can request based on the current time and merchant's pre-order time
    const minOrderTime = addMinutes(openingTime, preparationTime);
    const maxOrderTime = closingTime;
    const now = addMinutes(new Date(), preparationTime);

    // Check if the selected time is valid
    if (now > selectedDate || selectedDate < minOrderTime || selectedDate > maxOrderTime) {
      return { invalidDate: true };
    }

    return null;
};